import INewsResponse from "./models/INewsResponse";
import IPagination from "./models/IPagination";
import INewsArticle from "./models/INewsArticle";
import INewsApiConsumer from "./INewsApiConsumer";
import convertArticleResponse from "./converters/convertArticleResponse";
import EndpointsBaseClass from "apiConsumers/EndpointsBaseClass";
import QueryParameter from "apiConsumers/QueryParameter";

export default class NewsApiConsumer extends EndpointsBaseClass implements INewsApiConsumer {
    public async getAllArticles(pagination: IPagination = {}): Promise<INewsResponse> {
        let url = "/news";

        const { pageOffset, pageSize } = pagination;

        const queryParams = [
            new QueryParameter("pageOffset", pageOffset),
            new QueryParameter("pageSize", pageSize),
        ];

        const response = await this.makeGetRequest(url, queryParams);

        return response as INewsResponse;
    }

    public async getArticle(id: string): Promise<INewsArticle> {
        let url = `/news/article/${id}`;

        const response = await this.makeGetRequest(url);

        return convertArticleResponse(response);
    }
}
